const EXPIRY_BUFFER_SEC = 30;
/** Allow a stale access token briefly while refresh is unavailable (API/gateway restart). */
const OFFLINE_GRACE_SEC = 5 * 60;
function isRecoverableRefreshError(error) {
    if (!error)
        return true;
    const msg = (error.message ?? '').toLowerCase();
    if (msg.includes('fetch') || msg.includes('network') || msg.includes('failed to fetch')) {
        return true;
    }
    const status = error.status;
    if (status === 503 || status === 502 || status === 504)
        return true;
    return false;
}
export function syncAccessToken(session) {
    if (session?.access_token) {
        localStorage.setItem('sb-access-token', session.access_token);
    }
    else {
        localStorage.removeItem('sb-access-token');
    }
}
export function createSessionHelpers(supabase) {
    async function ensureFreshSession(session, opts) {
        const now = Math.floor(Date.now() / 1000);
        const expiresAt = session.expires_at ?? 0;
        if (!opts?.forceRefresh && expiresAt > now + EXPIRY_BUFFER_SEC)
            return session;
        try {
            const { data: { session: refreshed }, error, } = await supabase.auth.refreshSession();
            if (refreshed)
                return refreshed;
            if (isRecoverableRefreshError(error)) {
                if (expiresAt > now - OFFLINE_GRACE_SEC)
                    return session;
                return null;
            }
            await supabase.auth.signOut({ scope: 'local' });
            return null;
        }
        catch {
            if (expiresAt > now - OFFLINE_GRACE_SEC)
                return session;
            return null;
        }
    }
    async function resolveClientSession() {
        const { data: { session }, } = await supabase.auth.getSession();
        if (!session)
            return null;
        return ensureFreshSession(session);
    }
    async function tryRefreshSession() {
        const { data: { session }, } = await supabase.auth.getSession();
        if (!session)
            return null;
        return ensureFreshSession(session, { forceRefresh: true });
    }
    return {
        ensureFreshSession,
        resolveClientSession,
        tryRefreshSession,
    };
}
//# sourceMappingURL=session.js.map